var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lebegoad"}},[_c('Adsense',{attrs:{"data-ad-client":"ca-pub-4233283598404045","data-ad-slot":"9641742641","data-full-width-responsive":"yes","data-ad-format":"auto"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }